import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Box } from "rebass";
import { height, width } from "styled-system";

export const ActiveCircle = styled.div`
  background-color: #ffffff;
  border-radius: 50%;
  border: 1px solid #ffffff;
  width: 18px;
  height: 18px;
  overflow: hidden;
`;

export const InactiveCircle = styled.div`
  border-radius: 50%;
  border: 1px solid #ffffff;
  width: 18px;
  height: 18px;
  overflow: hidden;
`;

export const NoAvatar = styled.div`
  background-color: #ffffff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  margin-right: 5px;
  overflow: hidden;
`;

const StyledSvg = styled.svg`
  fill: ${(props) => props.color};
  ${width}
  ${height}
`;

export const GridIcon = ({ color, width, height }) => {
  return (
    <StyledSvg
      color={color}
      width={width}
      height={height}
      id="artboard-svg"
      viewBox="0 0 33 33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="clip-search_typedTableViewFilter">
          <path d="M0 0h1920v2126H0z" />
        </clipPath>
      </defs>
      <g transform="translate(-193 -175)">
        <g className="cls-1" id="search_typedTableViewFilter">
          <g
            id="Group_357"
            transform="translate(-580.258 116.742)"
            data-name="Group 357"
          >
            <rect
              className="cls-16"
              height="12.539"
              id="Rectangle_1514"
              width="12.539"
              rx="2"
              transform="translate(774 59)"
              data-name="Rectangle 1514"
            />
            <rect
              className="cls-16"
              height="12.539"
              id="Rectangle_1514-2"
              width="12.539"
              rx="2"
              transform="translate(790.719 59)"
              data-name="Rectangle 1514"
            />
            <rect
              className="cls-16"
              height="12.539"
              id="Rectangle_1514-3"
              width="12.539"
              rx="2"
              transform="translate(774 75.719)"
              data-name="Rectangle 1514"
            />
            <rect
              className="cls-16"
              height="12.539"
              id="Rectangle_1514-4"
              width="12.539"
              rx="2"
              transform="translate(790.719 75.719)"
              data-name="Rectangle 1514"
            />
          </g>
        </g>
      </g>
    </StyledSvg>
  );
};

GridIcon.propTypes = {
  color: PropTypes.string,
};

GridIcon.defaultProps = {
  color: "#969a9b",
  width: "20px",
  height: "20px",
};

export const ColumnIcon = ({ color, width, height }) => {
  return (
    <StyledSvg
      color={color}
      width={width}
      height={height}
      id="artboard-svg"
      viewBox="0 0 33 33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="clip-search_colViewWStatus">
          <path d="M0 0h1920v2126H0z" />
        </clipPath>
      </defs>
      <g transform="translate(-240 -175)">
        <g className="cls-1" id="search_colViewWStatus">
          <g
            id="Group_356"
            transform="translate(-536 114)"
            data-name="Group 356"
          >
            <rect
              className="cls-16"
              height="7.148"
              id="Rectangle_1513"
              width="29.39"
              rx="2"
              transform="translate(776.056 61.61)"
              data-name="Rectangle 1513"
            />
            <rect
              className="cls-16"
              height="7.148"
              id="Rectangle_1513-2"
              width="29.39"
              rx="2"
              transform="translate(776.056 72.731)"
              data-name="Rectangle 1513"
            />
            <rect
              className="cls-16"
              height="7.148"
              id="Rectangle_1513-3"
              width="29.39"
              rx="2"
              transform="translate(776.056 83.852)"
              data-name="Rectangle 1513"
            />
          </g>
        </g>
      </g>
    </StyledSvg>
  );
};

// export const ListIcon = styled(ColumnIcon)`
// 	${color}
//
// `

ColumnIcon.propTypes = {
  color: PropTypes.string,
};

ColumnIcon.defaultProps = {
  color: "#969a9b",
  width: "20px",
  height: "20px",
};

const StyledBackChev = styled.svg`
  fill: ${(props) => props.color};
  ${width}
  ${height}
	.cls-26 {
    fill: white;
  }
`;

export const BackChev = (props) => {
  return (
    <StyledBackChev
      height="51"
      id="artboard-svg"
      width="51"
      viewBox="0 0 51 51"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="clip-search_colViewProfile">
          <path d="M0 0h1920v2126H0z" />
        </clipPath>
      </defs>
      <g transform="translate(-68 -173)">
        <g className="cls-1" id="search_colViewProfile">
          <g
            id="Group_319"
            transform="rotate(180 57.937 110.5)"
            data-name="Group 319"
          >
            <g
              className="cls-28"
              id="_"
              transform="rotate(180 57.935 110.5)"
              data-name="+"
            >
              <path
                className="cls-26"
                id="Path_2-2"
                d="M23.816 0A23.816 23.816 0 1 1 0 23.816 23.816 23.816 0 0 1 23.816 0z"
                transform="rotate(180 57.935 110.5)"
                data-name="Path 2"
              />
            </g>
            <g
              id="Symbol_1_17"
              transform="translate(-438.805 -153.805)"
              data-name="Symbol 1 – 17"
            >
              <path
                className="cls-13"
                id="Rectangle_556"
                d="M0 0h16v16H0z"
                transform="translate(455 170)"
                data-name="Rectangle 556"
              />
            </g>
          </g>
        </g>
      </g>
    </StyledBackChev>
  );
};

// ColumnIcon.propTypes = {
// 	color: PropTypes.string
// }
//
// ColumnIcon.defaultProps = {
// 	color: "#969a9b",
// 	width: '20px',
// 	height: '20px'
// }

const InactiveHomeStyle = styled(Box)`
  .cls-1 {
    clip-path: url(#clip-chat_main);
  }
  .cls-11,
  .cls-13,
  .cls-15,
  .cls-18,
  .cls-2,
  .cls-23 {
    fill: #fff;
  }
  .cls-10,
  .cls-3,
  .cls-8,
  .cls-9 {
    fill: #263039;
  }
  .cls-3 {
    font-size: 21px;
  }
  .cls-10,
  .cls-3,
  .cls-9 {
    font-family: AvenirNext-Bold, Avenir Next;
    font-weight: 700;
  }
  .cls-4 {
    fill: #707070;
    stroke: #707070;
  }
  .cls-12,
  .cls-22,
  .cls-5 {
    fill: #2b80b9;
  }
  .cls-17,
  .cls-19,
  .cls-21,
  .cls-6 {
    fill: none;
  }
  .cls-6 {
    stroke: #f0efef;
  }
  .cls-7 {
    fill: #969a9b;
  }
  .cls-7,
  .cls-9 {
    font-size: 12px;
  }
  .cls-11,
  .cls-7,
  .cls-8 {
    font-family: AvenirNext-DemiBold, Avenir Next;
    font-weight: 300;
  }
  .cls-10,
  .cls-8 {
    font-size: 15px;
  }
  .cls-11 {
    font-size: 9px;
  }
  .cls-13,
  .cls-15,
  .cls-18,
  .cls-19 {
    stroke: #fff;
  }
  .cls-13 {
    stroke-width: 0.5px;
  }
  .cls-14,
  .cls-16 {
    fill: #121212;
  }
  .cls-15,
  .cls-19 {
    stroke-width: 2px;
  }
  .cls-16 {
    stroke: #121212;
  }
  .cls-20,
  .cls-22,
  .cls-23 {
    stroke: none;
  }
  .cls-24 {
    filter: url(#Rectangle_1458);
  }
  .cls-25 {
    filter: url(#Path_2);
  }
  .cls-26 {
    filter: url(#Rectangle_7);
  }
`;

export const HomeInactive = () => (
  <InactiveHomeStyle>
    <svg
      height="34"
      id="artboard-svg"
      width="34"
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="clip-chat_main">
          <path d="M0 0h375v667H0z" />
        </clipPath>
      </defs>
      <g transform="translate(-68 -624)">
        <g className="cls-1" id="chat_main">
          <g id="Group_6" data-name="Group 6">
            <g id="HomeInactive">
              <g className="cls-17" id="Path_130" data-name="Path 130">
                <path
                  className="cls-20"
                  d="M12 0A12 12 0 1 1 0 12 12 12 0 0 1 12 0z"
                  transform="translate(68.78 624.78)"
                />
                <path
                  className="cls-23"
                  d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2m0-2c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0z"
                  transform="translate(68.78 624.78)"
                />
              </g>
              <g id="home" transform="translate(74.192 602.972)">
                <g
                  id="Group_354"
                  transform="translate(-.001 27.798)"
                  data-name="Group 354"
                >
                  <g id="Group_353" data-name="Group 353">
                    <path
                      className="cls-18"
                      id="Path_128"
                      d="M12.1 32.1l-5.8-4.241a.318.318 0 0 0-.375 0L.13 32.1a.318.318 0 0 0 .375.513l5.61-4.107 5.61 4.107a.318.318 0 0 0 .375-.513z"
                      transform="translate(.001 -27.798)"
                      data-name="Path 128"
                    />
                  </g>
                </g>
                <g
                  id="Group_356"
                  transform="translate(1.348 32.688)"
                  data-name="Group 356"
                >
                  <g id="Group_355" data-name="Group 355">
                    <path
                      className="cls-18"
                      id="Path_129"
                      d="M65.668 232.543a.318.318 0 0 0-.318.318v5.058h-2.542v-2.761a1.589 1.589 0 1 0-3.178 0v2.761h-2.542v-5.058a.318.318 0 0 0-.636 0v5.376a.318.318 0 0 0 .318.318h3.178a.318.318 0 0 0 .317-.293.242.242 0 0 0 0-.025v-3.079a.953.953 0 0 1 1.907 0v3.079a.238.238 0 0 0 0 .024.318.318 0 0 0 .317.293h3.178a.318.318 0 0 0 .318-.318v-5.376a.318.318 0 0 0-.317-.317z"
                      transform="translate(-56.452 -232.543)"
                      data-name="Path 129"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </InactiveHomeStyle>
);

const HomeStyles = styled(Box)`
  .cls-1 {
    clip-path: url(#clip-posts_main);
  }
  .cls-11,
  .cls-2,
  .cls-4,
  .cls-8 {
    fill: #263039;
  }
  .cls-2 {
    font-size: 17px;
  }
  .cls-11,
  .cls-2,
  .cls-8 {
    font-family: AvenirNext-Bold, Avenir Next;
    font-weight: 700;
  }
  .cls-16,
  .cls-18,
  .cls-3,
  .cls-5 {
    fill: #969a9b;
  }
  .cls-3 {
    font-size: 11px;
  }
  .cls-16,
  .cls-3,
  .cls-4,
  .cls-5 {
    font-family: AvenirNext-DemiBold, Avenir Next;
    font-weight: 300;
  }
  .cls-4,
  .cls-5 {
    font-size: 9px;
  }
  .cls-13,
  .cls-17,
  .cls-6 {
    fill: none;
  }
  .cls-6 {
    stroke: #dedddd;
  }
  .cls-20,
  .cls-6 {
    stroke-width: 0.5px;
  }
  .cls-10,
  .cls-14,
  .cls-20,
  .cls-22,
  .cls-7 {
    fill: #fff;
  }
  .cls-8 {
    font-size: 21px;
  }
  .cls-9 {
    fill: #707070;
    stroke: #707070;
  }
  .cls-10,
  .cls-13,
  .cls-20 {
    stroke: #fff;
  }
  .cls-11,
  .cls-16 {
    font-size: 15px;
  }
  .cls-12,
  .cls-15 {
    fill: #121212;
  }
  .cls-13 {
    stroke-width: 2px;
  }
  .cls-15 {
    stroke: #121212;
  }
  .cls-19 {
    fill: #2b80b9;
  }
  .cls-21,
  .cls-22 {
    stroke: none;
  }
  .cls-23 {
    filter: url(#Path_2);
  }
  .cls-24 {
    filter: url(#Rectangle_3-2);
  }
  .cls-25 {
    filter: url(#Rectangle_1458);
  }
  .cls-26 {
    filter: url(#Rectangle_3);
  }
  .cls-27 {
    filter: url(#Rectangle_4);
  }
`;

export const Home = (props) => {
  return (
    <HomeStyles>
      <svg
        height="34"
        id="artboard-svg"
        width="34"
        viewBox="0 0 26 26"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <clipPath id="clip-posts_main">
            <path d="M0 0h375v667H0z" />
          </clipPath>
        </defs>
        <g transform="translate(-68 -624)">
          <g className="cls-1" id="posts_main">
            <g id="Group_6" data-name="Group 6">
              <g id="Home">
                <g className="cls-14" id="Path_130" data-name="Path 130">
                  <path
                    className="cls-21"
                    d="M12 23c-2.938 0-5.7-1.144-7.778-3.222A10.928 10.928 0 0 1 1 12c0-2.938 1.144-5.7 3.222-7.778A10.928 10.928 0 0 1 12 1c2.938 0 5.7 1.144 7.778 3.222A10.928 10.928 0 0 1 23 12c0 2.938-1.144 5.7-3.222 7.778A10.928 10.928 0 0 1 12 23z"
                    transform="translate(68.78 624.78)"
                  />
                  <path
                    className="cls-22"
                    d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2m0-2c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0z"
                    transform="translate(68.78 624.78)"
                  />
                </g>
                <g
                  id="home-2"
                  transform="translate(74.192 602.972)"
                  data-name="home"
                >
                  <g
                    id="Group_354"
                    transform="translate(-.001 27.798)"
                    data-name="Group 354"
                  >
                    <g id="Group_353" data-name="Group 353">
                      <path
                        className="cls-15"
                        id="Path_128"
                        d="M12.1 32.1l-5.8-4.241a.318.318 0 0 0-.375 0L.13 32.1a.318.318 0 0 0 .375.513l5.61-4.107 5.61 4.107a.318.318 0 0 0 .375-.513z"
                        transform="translate(.001 -27.798)"
                        data-name="Path 128"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_356"
                    transform="translate(1.348 32.688)"
                    data-name="Group 356"
                  >
                    <g id="Group_355" data-name="Group 355">
                      <path
                        className="cls-15"
                        id="Path_129"
                        d="M65.668 232.543a.318.318 0 0 0-.318.318v5.058h-2.542v-2.761a1.589 1.589 0 1 0-3.178 0v2.761h-2.542v-5.058a.318.318 0 0 0-.636 0v5.376a.318.318 0 0 0 .318.318h3.178a.318.318 0 0 0 .317-.293.242.242 0 0 0 0-.025v-3.079a.953.953 0 0 1 1.907 0v3.079a.238.238 0 0 0 0 .024.318.318 0 0 0 .317.293h3.178a.318.318 0 0 0 .318-.318v-5.376a.318.318 0 0 0-.317-.317z"
                        transform="translate(-56.452 -232.543)"
                        data-name="Path 129"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </HomeStyles>
  );
};

const InactiveLeaveStyle = styled(Box)`
  .cls-1 {
    clip-path: url(#clip-posts_main);
  }
  .cls-11,
  .cls-2,
  .cls-4,
  .cls-8 {
    fill: #263039;
  }
  .cls-2 {
    font-size: 17px;
  }
  .cls-11,
  .cls-2,
  .cls-8 {
    font-family: AvenirNext-Bold, Avenir Next;
    font-weight: 700;
  }
  .cls-16,
  .cls-18,
  .cls-3,
  .cls-5 {
    fill: #969a9b;
  }
  .cls-3 {
    font-size: 11px;
  }
  .cls-16,
  .cls-3,
  .cls-4,
  .cls-5 {
    font-family: AvenirNext-DemiBold, Avenir Next;
    font-weight: 300;
  }
  .cls-4,
  .cls-5 {
    font-size: 9px;
  }
  .cls-13,
  .cls-17,
  .cls-6 {
    fill: none;
  }
  .cls-6 {
    stroke: #dedddd;
  }
  .cls-20,
  .cls-6 {
    stroke-width: 0.5px;
  }
  .cls-10,
  .cls-14,
  .cls-20,
  .cls-22,
  .cls-7 {
    fill: #fff;
  }
  .cls-8 {
    font-size: 21px;
  }
  .cls-9 {
    fill: #707070;
    stroke: #707070;
  }
  .cls-10,
  .cls-13,
  .cls-20 {
    stroke: #fff;
  }
  .cls-11,
  .cls-16 {
    font-size: 15px;
  }
  .cls-12,
  .cls-15 {
    fill: #121212;
  }
  .cls-13 {
    stroke-width: 2px;
  }
  .cls-15 {
    stroke: #121212;
  }
  .cls-19 {
    fill: #2b80b9;
  }
  .cls-21,
  .cls-22 {
    stroke: none;
  }
  .cls-23 {
    filter: url(#Path_2);
  }
  .cls-24 {
    filter: url(#Rectangle_3-2);
  }
  .cls-25 {
    filter: url(#Rectangle_1458);
  }
  .cls-26 {
    filter: url(#Rectangle_3);
  }
  .cls-27 {
    filter: url(#Rectangle_4);
  }
`;

export const LeavesInactive = () => (
  <InactiveLeaveStyle>
    <svg
      height="34"
      id="artboard-svg"
      width="34"
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="clip-posts_main">
          <path d="M0 0h375v667H0z" />
        </clipPath>
      </defs>
      <g transform="translate(-173 -624)">
        <g className="cls-1" id="posts_main">
          <g id="Group_6" data-name="Group 6">
            <g id="Leaves">
              <g
                className="cls-13"
                id="Ellipse_29-2"
                transform="translate(174 625)"
                data-name="Ellipse 29"
              >
                <circle className="cls-21" cx="12" cy="12" r="12" />
                <circle className="cls-17" cx="12" cy="12" r="11" />
              </g>
              <g
                id="logout"
                transform="translate(169.781 633.984)  scale(0.75)"
              >
                <g
                  id="Group_357"
                  transform="translate(17.219)"
                  data-name="Group 357"
                >
                  <path
                    className="cls-10"
                    id="Path_131"
                    d="M21.951 8.628h-2.764a1.28 1.28 0 0 1-1.361-1.175V1.7A1.28 1.28 0 0 1 19.187.524H22a.284.284 0 0 0 .3-.262A.284.284 0 0 0 22 0h-2.813a1.851 1.851 0 0 0-1.968 1.7v5.753a1.851 1.851 0 0 0 1.968 1.7h2.764a.265.265 0 1 0 0-.524z"
                    transform="translate(-17.219)"
                    data-name="Path 131"
                  />
                  <path
                    className="cls-10"
                    id="Path_132"
                    d="M127.929 138.344l-1.93-1.93a.3.3 0 0 0-.43.43l1.412 1.412h-6.16a.3.3 0 0 0 0 .607h6.16l-1.412 1.412a.3.3 0 0 0 .214.52.3.3 0 0 0 .214-.09l1.93-1.93a.3.3 0 0 0 .002-.431z"
                    transform="translate(-119.692 -133.982)"
                    data-name="Path 132"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </InactiveLeaveStyle>
);

const ActiveLeaveStyle = styled(Box)`
  .cls-1 {
    clip-path: url(#clip-airportView_pendingAll);
  }
  .cls-2 {
    fill: #2b80b9;
  }
  .cls-17,
  .cls-19,
  .cls-22,
  .cls-26,
  .cls-3,
  .cls-4,
  .cls-8 {
    fill: #fff;
  }
  .cls-19,
  .cls-21,
  .cls-22,
  .cls-3 {
    stroke: #fff;
  }
  .cls-10,
  .cls-3 {
    stroke-width: 0.5px;
  }
  .cls-14,
  .cls-15,
  .cls-16,
  .cls-5,
  .cls-6 {
    fill: #263039;
  }
  .cls-5 {
    font-size: 21px;
  }
  .cls-12,
  .cls-15,
  .cls-5 {
    font-family: AvenirNext-Bold, Avenir Next;
    font-weight: 700;
  }
  .cls-6,
  .cls-7 {
    font-size: 14px;
  }
  .cls-13,
  .cls-14,
  .cls-16,
  .cls-17,
  .cls-6,
  .cls-7 {
    font-family: AvenirNext-DemiBold, Avenir Next;
    font-weight: 300;
  }
  .cls-13,
  .cls-7 {
    fill: #969a9b;
  }
  .cls-8 {
    stroke: #2b80b9;
  }
  .cls-9 {
    fill: #707070;
    stroke: #707070;
  }
  .cls-10,
  .cls-20,
  .cls-21,
  .cls-25 {
    fill: none;
  }
  .cls-10 {
    stroke: #dedddd;
  }
  .cls-11 {
    fill: #ffc61a;
    stroke: #ffc61a;
  }
  .cls-12 {
    fill: #f95050;
  }
  .cls-12,
  .cls-15 {
    font-size: 17px;
  }
  .cls-13,
  .cls-14 {
    font-size: 11px;
  }
  .cls-16,
  .cls-17 {
    font-size: 9.5px;
  }
  .cls-18,
  .cls-23 {
    fill: #121212;
  }
  .cls-21,
  .cls-22 {
    stroke-width: 2px;
  }
  .cls-23 {
    stroke: #121212;
  }
  .cls-24,
  .cls-26 {
    stroke: none;
  }
  .cls-27 {
    filter: url(#Rectangle_1458-6);
  }
  .cls-28 {
    filter: url(#Rectangle_1458-5);
  }
  .cls-29 {
    filter: url(#Rectangle_1458-4);
  }
  .cls-30 {
    filter: url(#Rectangle_1458-3);
  }
  .cls-31 {
    filter: url(#Rectangle_1458-2);
  }
  .cls-32 {
    filter: url(#Rectangle_1458);
  }
  .cls-33 {
    filter: url(#Rectangle_7);
  }
  .cls-34 {
    filter: url(#Path_2);
  }
`;

export const LeavesActive = () => (
  <ActiveLeaveStyle>
    <svg
      height="34"
      id="artboard-svg"
      width="34"
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="clip-airportView_pendingAll">
          <path d="M0 0h375v667H0z" />
        </clipPath>
      </defs>
      <g transform="translate(-173 -624)">
        <g className="cls-1" id="airportView_pendingAll">
          <g id="Group_6" data-name="Group 6">
            <g id="LeavesActive">
              <g
                className="cls-22"
                id="Ellipse_29-2"
                transform="translate(174 625)"
                data-name="Ellipse 29"
              >
                <circle className="cls-24" cx="12" cy="12" r="12" />
                <circle className="cls-25" cx="12" cy="12" r="11" />
              </g>
              <g
                id="logout"
                transform="translate(169.781 633.984)  scale(0.75)"
              >
                <g
                  id="Group_357"
                  transform="translate(17.219)"
                  data-name="Group 357"
                >
                  <path
                    className="cls-23"
                    id="Path_131"
                    d="M21.951 8.628h-2.764a1.28 1.28 0 0 1-1.361-1.175V1.7A1.28 1.28 0 0 1 19.187.524H22a.284.284 0 0 0 .3-.262A.284.284 0 0 0 22 0h-2.813a1.851 1.851 0 0 0-1.968 1.7v5.753a1.851 1.851 0 0 0 1.968 1.7h2.764a.265.265 0 1 0 0-.524z"
                    transform="translate(-17.219)"
                    data-name="Path 131"
                  />
                  <path
                    className="cls-23"
                    id="Path_132"
                    d="M127.929 138.344l-1.93-1.93a.3.3 0 0 0-.43.43l1.412 1.412h-6.16a.3.3 0 0 0 0 .607h6.16l-1.412 1.412a.3.3 0 0 0 .214.52.3.3 0 0 0 .214-.09l1.93-1.93a.3.3 0 0 0 .002-.431z"
                    transform="translate(-119.692 -133.982)"
                    data-name="Path 132"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </ActiveLeaveStyle>
);

const InactiveCalendarStyle = styled(Box)`
  .cls-1 {
    clip-path: url(#clip-posts_main);
  }
  .cls-11,
  .cls-2,
  .cls-4,
  .cls-8 {
    fill: #263039;
  }
  .cls-2 {
    font-size: 17px;
  }
  .cls-11,
  .cls-2,
  .cls-8 {
    font-family: AvenirNext-Bold, Avenir Next;
    font-weight: 700;
  }
  .cls-16,
  .cls-18,
  .cls-3,
  .cls-5 {
    fill: #969a9b;
  }
  .cls-3 {
    font-size: 11px;
  }
  .cls-16,
  .cls-3,
  .cls-4,
  .cls-5 {
    font-family: AvenirNext-DemiBold, Avenir Next;
    font-weight: 300;
  }
  .cls-4,
  .cls-5 {
    font-size: 9px;
  }
  .cls-13,
  .cls-17,
  .cls-6 {
    fill: none;
  }
  .cls-6 {
    stroke: #dedddd;
  }
  .cls-20,
  .cls-6 {
    stroke-width: 0.5px;
  }
  .cls-10,
  .cls-14,
  .cls-20,
  .cls-22,
  .cls-7 {
    fill: #fff;
  }
  .cls-8 {
    font-size: 21px;
  }
  .cls-9 {
    fill: #707070;
    stroke: #707070;
  }
  .cls-10,
  .cls-13,
  .cls-20 {
    stroke: #fff;
  }
  .cls-11,
  .cls-16 {
    font-size: 15px;
  }
  .cls-12,
  .cls-15 {
    fill: #121212;
  }
  .cls-13 {
    stroke-width: 2px;
  }
  .cls-15 {
    stroke: #121212;
  }
  .cls-19 {
    fill: #2b80b9;
  }
  .cls-21,
  .cls-22 {
    stroke: none;
  }
  .cls-23 {
    filter: url(#Path_2);
  }
  .cls-24 {
    filter: url(#Rectangle_3-2);
  }
  .cls-25 {
    filter: url(#Rectangle_1458);
  }
  .cls-26 {
    filter: url(#Rectangle_3);
  }
  .cls-27 {
    filter: url(#Rectangle_4);
  }
`;

export const CalendarInactive = () => (
  <InactiveCalendarStyle>
    <svg
      height="34"
      id="artboard-svg"
      width="34"
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="clip-posts_main">
          <path d="M0 0h375v667H0z" />
        </clipPath>
      </defs>
      <g transform="translate(-173 -624)">
        <g className="cls-1" id="posts_main">
          <g id="Group_6" data-name="Group 6">
            <g id="Leaves">
              <g
                className="cls-13"
                id="Ellipse_29-2"
                transform="translate(174 625)"
                data-name="Ellipse 29"
              >
                <circle className="cls-21" cx="12" cy="12" r="12" />
                <circle className="cls-17" cx="12" cy="12" r="11" />
              </g>
              <g
                id="logout"
                transform="translate(169.781 633.984)  scale(0.75)"
              >
                <g
                  id="Group_357"
                  transform="translate(17.219)"
                  data-name="Group 357"
                >
                  <path
                    fill="none"
                    d="M0 0h24v24H0z"
                    // transform="translate(-17.219)"
                    data-name="Path 131"
                  />
                  <path
                    fill="#ffffff"
                    d="M18 4h-1V2h-2v2H9V2H7v2H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zM7 8h10v2H7V8zm0 4h10v2H7v-2z"
                    transform="translate(-7.692 -7.982)"
                    data-name="Path 132"
                  />

                  {/* <path
                    className="cls-10"
                    id="Path_131"
                    d="M21.951 8.628h-2.764a1.28 1.28 0 0 1-1.361-1.175V1.7A1.28 1.28 0 0 1 19.187.524H22a.284.284 0 0 0 .3-.262A.284.284 0 0 0 22 0h-2.813a1.851 1.851 0 0 0-1.968 1.7v5.753a1.851 1.851 0 0 0 1.968 1.7h2.764a.265.265 0 1 0 0-.524z"
                    transform="translate(-17.219)"
                    data-name="Path 131"
                  />
                  <path
                    className="cls-10"
                    id="Path_132"
                    d="M127.929 138.344l-1.93-1.93a.3.3 0 0 0-.43.43l1.412 1.412h-6.16a.3.3 0 0 0 0 .607h6.16l-1.412 1.412a.3.3 0 0 0 .214.52.3.3 0 0 0 .214-.09l1.93-1.93a.3.3 0 0 0 .002-.431z"
                    transform="translate(-119.692 -133.982)"
                    data-name="Path 132"
                  /> */}
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </InactiveCalendarStyle>
);

const ActiveCalendarStyle = styled(Box)`
  .cls-1 {
    clip-path: url(#clip-airportView_pendingAll);
  }
  .cls-2 {
    fill: #2b80b9;
  }
  .cls-17,
  .cls-19,
  .cls-22,
  .cls-26,
  .cls-3,
  .cls-4,
  .cls-8 {
    fill: #fff;
  }
  .cls-19,
  .cls-21,
  .cls-22,
  .cls-3 {
    stroke: #fff;
  }
  .cls-10,
  .cls-3 {
    stroke-width: 0.5px;
  }
  .cls-14,
  .cls-15,
  .cls-16,
  .cls-5,
  .cls-6 {
    fill: #263039;
  }
  .cls-5 {
    font-size: 21px;
  }
  .cls-12,
  .cls-15,
  .cls-5 {
    font-family: AvenirNext-Bold, Avenir Next;
    font-weight: 700;
  }
  .cls-6,
  .cls-7 {
    font-size: 14px;
  }
  .cls-13,
  .cls-14,
  .cls-16,
  .cls-17,
  .cls-6,
  .cls-7 {
    font-family: AvenirNext-DemiBold, Avenir Next;
    font-weight: 300;
  }
  .cls-13,
  .cls-7 {
    fill: #969a9b;
  }
  .cls-8 {
    stroke: #2b80b9;
  }
  .cls-9 {
    fill: #707070;
    stroke: #707070;
  }
  .cls-10,
  .cls-20,
  .cls-21,
  .cls-25 {
    fill: none;
  }
  .cls-10 {
    stroke: #dedddd;
  }
  .cls-11 {
    fill: #ffc61a;
    stroke: #ffc61a;
  }
  .cls-12 {
    fill: #f95050;
  }
  .cls-12,
  .cls-15 {
    font-size: 17px;
  }
  .cls-13,
  .cls-14 {
    font-size: 11px;
  }
  .cls-16,
  .cls-17 {
    font-size: 9.5px;
  }
  .cls-18,
  .cls-23 {
    fill: #121212;
  }
  .cls-21,
  .cls-22 {
    stroke-width: 2px;
  }
  .cls-23 {
    stroke: #121212;
  }
  .cls-24,
  .cls-26 {
    stroke: none;
  }
  .cls-27 {
    filter: url(#Rectangle_1458-6);
  }
  .cls-28 {
    filter: url(#Rectangle_1458-5);
  }
  .cls-29 {
    filter: url(#Rectangle_1458-4);
  }
  .cls-30 {
    filter: url(#Rectangle_1458-3);
  }
  .cls-31 {
    filter: url(#Rectangle_1458-2);
  }
  .cls-32 {
    filter: url(#Rectangle_1458);
  }
  .cls-33 {
    filter: url(#Rectangle_7);
  }
  .cls-34 {
    filter: url(#Path_2);
  }
`;

export const CalendarActive = () => (
  <ActiveCalendarStyle>
    <svg
      height="34"
      id="artboard-svg"
      width="34"
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="clip-airportView_pendingAll">
          <path d="M0 0h375v667H0z" />
        </clipPath>
      </defs>
      <g transform="translate(-173 -624)">
        <g className="cls-1" id="airportView_pendingAll">
          <g id="Group_6" data-name="Group 6">
            <g id="LeavesActive">
              <g
                className="cls-22"
                id="Ellipse_29-2"
                transform="translate(174 625)"
                data-name="Ellipse 29"
              >
                <circle className="cls-24" cx="12" cy="12" r="12" />
                <circle className="cls-25" cx="12" cy="12" r="11" />
              </g>
              <g
                id="logout"
                transform="translate(169.781 633.984)  scale(0.75)"
              >
                <g
                  id="Group_357"
                  transform="translate(17.219)"
                  data-name="Group 357"
                >
                  <path
                    fill="none"
                    d="M0 0h24v24H0z"
                    // transform="translate(-17.219)"
                    data-name="Path 131"
                  />
                  <path
                    d="M18 4h-1V2h-2v2H9V2H7v2H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zM7 8h10v2H7V8zm0 4h10v2H7v-2z"
                    transform="translate(-7.692 -7.982)"
                    data-name="Path 132"
                  />

                  {/* <path
                    className="cls-23"
                    id="Path_131"
                    d="M21.951 8.628h-2.764a1.28 1.28 0 0 1-1.361-1.175V1.7A1.28 1.28 0 0 1 19.187.524H22a.284.284 0 0 0 .3-.262A.284.284 0 0 0 22 0h-2.813a1.851 1.851 0 0 0-1.968 1.7v5.753a1.851 1.851 0 0 0 1.968 1.7h2.764a.265.265 0 1 0 0-.524z"
                    transform="translate(-17.219)"
                    data-name="Path 131"
                  />
                  <path
                    className="cls-23"
                    id="Path_132"
                    d="M127.929 138.344l-1.93-1.93a.3.3 0 0 0-.43.43l1.412 1.412h-6.16a.3.3 0 0 0 0 .607h6.16l-1.412 1.412a.3.3 0 0 0 .214.52.3.3 0 0 0 .214-.09l1.93-1.93a.3.3 0 0 0 .002-.431z"
                    transform="translate(-119.692 -133.982)"
                    data-name="Path 132"
                  /> */}
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </ActiveCalendarStyle>
);

const ActiveChatStyle = styled(Box)`
  .cls-1 {
    clip-path: url(#clip-chat_main);
  }
  .cls-11,
  .cls-13,
  .cls-16,
  .cls-18,
  .cls-2,
  .cls-23 {
    fill: #fff;
  }
  .cls-10,
  .cls-3,
  .cls-8,
  .cls-9 {
    fill: #263039;
  }
  .cls-3 {
    font-size: 21px;
  }
  .cls-10,
  .cls-3,
  .cls-9 {
    font-family: AvenirNext-Bold, Avenir Next;
    font-weight: 700;
  }
  .cls-4 {
    fill: #707070;
    stroke: #707070;
  }
  .cls-12,
  .cls-22,
  .cls-5 {
    fill: #2b80b9;
  }
  .cls-15,
  .cls-19,
  .cls-21,
  .cls-6 {
    fill: none;
  }
  .cls-6 {
    stroke: #f0efef;
  }
  .cls-7 {
    fill: #969a9b;
  }
  .cls-7,
  .cls-9 {
    font-size: 12px;
  }
  .cls-11,
  .cls-7,
  .cls-8 {
    font-family: AvenirNext-DemiBold, Avenir Next;
    font-weight: 300;
  }
  .cls-10,
  .cls-8 {
    font-size: 15px;
  }
  .cls-11 {
    font-size: 9px;
  }
  .cls-13,
  .cls-16,
  .cls-18,
  .cls-19 {
    stroke: #fff;
  }
  .cls-13 {
    stroke-width: 0.5px;
  }
  .cls-14,
  .cls-17 {
    fill: #121212;
  }
  .cls-16,
  .cls-19 {
    stroke-width: 2px;
  }
  .cls-17 {
    stroke: #121212;
  }
  .cls-20,
  .cls-22,
  .cls-23 {
    stroke: none;
  }
  .cls-24 {
    filter: url(#Rectangle_1458);
  }
  .cls-25 {
    filter: url(#Path_2);
  }
  .cls-26 {
    filter: url(#Rectangle_7);
  }
`;
export const ChatActive = (props) => (
  <ActiveChatStyle>
    <svg
      height="34"
      id="artboard-svg"
      width="34"
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="clip-chat_main">
          <path d="M0 0h375v667H0z" />
        </clipPath>
      </defs>
      <g transform="translate(-278 -624)">
        <g className="cls-1" id="chat_main">
          <g id="Group_6" data-name="Group 6">
            <g id="ChatActive">
              <g
                className="cls-16"
                id="Ellipse_29"
                transform="translate(279 625)"
                data-name="Ellipse 29"
              >
                <circle className="cls-20" cx="12" cy="12" r="12" />
                <circle className="cls-21" cx="12" cy="12" r="11" />
              </g>
              <g id="speech-bubble" transform="translate(285.413 627.887)">
                <path
                  className="cls-17"
                  id="Path_133"
                  d="M8.993 5.5a5.894 5.894 0 0 0-3.708-1.243A5.894 5.894 0 0 0 1.576 5.5 3.971 3.971 0 0 0 0 8.6a3.971 3.971 0 0 0 1.576 3.1 5.894 5.894 0 0 0 3.709 1.247c.142 0 .286 0 .428-.014l.9 1.484a.357.357 0 0 0 .3.172h.008a.357.357 0 0 0 .3-.158l1.899-2.843A3.943 3.943 0 0 0 10.569 8.6a3.971 3.971 0 0 0-1.576-3.1zM8.6 11.1l-1.666 2.463-.725-1.2A.357.357 0 0 0 5.9 12.2h-.036a5.809 5.809 0 0 1-.583.029C2.764 12.227.714 10.6.714 8.6s2.05-3.628 4.57-3.628S9.855 6.6 9.855 8.6A3.26 3.26 0 0 1 8.6 11.1z"
                  data-name="Path 133"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </ActiveChatStyle>
);

const InactiveChatStyle = styled(Box)`
  .cls-1 {
    clip-path: url(#clip-posts_main);
  }
  .cls-11,
  .cls-2,
  .cls-4,
  .cls-8 {
    fill: #263039;
  }
  .cls-2 {
    font-size: 17px;
  }
  .cls-11,
  .cls-2,
  .cls-8 {
    font-family: AvenirNext-Bold, Avenir Next;
    font-weight: 700;
  }
  .cls-16,
  .cls-18,
  .cls-3,
  .cls-5 {
    fill: #969a9b;
  }
  .cls-3 {
    font-size: 11px;
  }
  .cls-16,
  .cls-3,
  .cls-4,
  .cls-5 {
    font-family: AvenirNext-DemiBold, Avenir Next;
    font-weight: 300;
  }
  .cls-4,
  .cls-5 {
    font-size: 9px;
  }
  .cls-13,
  .cls-17,
  .cls-6 {
    fill: none;
  }
  .cls-6 {
    stroke: #dedddd;
  }
  .cls-20,
  .cls-6 {
    stroke-width: 0.5px;
  }
  .cls-10,
  .cls-14,
  .cls-20,
  .cls-22,
  .cls-7 {
    fill: #fff;
  }
  .cls-8 {
    font-size: 21px;
  }
  .cls-9 {
    fill: #707070;
    stroke: #707070;
  }
  .cls-10,
  .cls-13,
  .cls-20 {
    stroke: #fff;
  }
  .cls-11,
  .cls-16 {
    font-size: 15px;
  }
  .cls-12,
  .cls-15 {
    fill: #121212;
  }
  .cls-13 {
    stroke-width: 2px;
  }
  .cls-15 {
    stroke: #121212;
  }
  .cls-19 {
    fill: #2b80b9;
  }
  .cls-21,
  .cls-22 {
    stroke: none;
  }
  .cls-23 {
    filter: url(#Path_2);
  }
  .cls-24 {
    filter: url(#Rectangle_3-2);
  }
  .cls-25 {
    filter: url(#Rectangle_1458);
  }
  .cls-26 {
    filter: url(#Rectangle_3);
  }
  .cls-27 {
    filter: url(#Rectangle_4);
  }
`;

export const ChatInactive = () => (
  <InactiveChatStyle>
    <svg
      height="34"
      id="artboard-svg"
      width="34"
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="clip-posts_main">
          <path d="M0 0h375v667H0z" />
        </clipPath>
      </defs>
      <g transform="translate(-278 -624)">
        <g className="cls-1" id="posts_main">
          <g id="Group_6" data-name="Group 6">
            <g id="Chat">
              <g id="speech-bubble" transform="translate(285.413 627.887)">
                <path
                  className="cls-10"
                  id="Path_133"
                  d="M8.993 5.5a5.894 5.894 0 0 0-3.708-1.243A5.894 5.894 0 0 0 1.576 5.5 3.971 3.971 0 0 0 0 8.6a3.971 3.971 0 0 0 1.576 3.1 5.894 5.894 0 0 0 3.709 1.247c.142 0 .286 0 .428-.014l.9 1.484a.357.357 0 0 0 .3.172h.008a.357.357 0 0 0 .3-.158l1.899-2.843A3.943 3.943 0 0 0 10.569 8.6a3.971 3.971 0 0 0-1.576-3.1zM8.6 11.1l-1.666 2.463-.725-1.2A.357.357 0 0 0 5.9 12.2h-.036a5.809 5.809 0 0 1-.583.029C2.764 12.227.714 10.6.714 8.6s2.05-3.628 4.57-3.628S9.855 6.6 9.855 8.6A3.26 3.26 0 0 1 8.6 11.1z"
                  data-name="Path 133"
                />
              </g>
              <g
                className="cls-13"
                id="Ellipse_29"
                transform="translate(279 625)"
                data-name="Ellipse 29"
              >
                <circle className="cls-21" cx="12" cy="12" r="12" />
                <circle className="cls-17" cx="12" cy="12" r="11" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </InactiveChatStyle>
);

const ActiveCheckinStyle = styled(Box)`
  .cls-1,
  .cls-22 {
    fill: none;
  }
  .cls-2 {
    clip-path: url(#clip-checkIn_viewCheckInColView);
  }
  .cls-10,
  .cls-23,
  .cls-24,
  .cls-26,
  .cls-3,
  .cls-7 {
    fill: #fff;
  }
  .cls-13,
  .cls-4,
  .cls-5,
  .cls-8 {
    fill: #263039;
  }
  .cls-4 {
    font-size: 21px;
  }
  .cls-10,
  .cls-17,
  .cls-4 {
    font-family: AvenirNext-Bold, Avenir Next;
    font-weight: 700;
  }
  .cls-5,
  .cls-6 {
    font-size: 14px;
  }
  .cls-11,
  .cls-13,
  .cls-18,
  .cls-21,
  .cls-5,
  .cls-6 {
    font-family: AvenirNext-DemiBold, Avenir Next;
    font-weight: 300;
  }
  .cls-11,
  .cls-14,
  .cls-17,
  .cls-18,
  .cls-19,
  .cls-21,
  .cls-6,
  .cls-9 {
    fill: #969a9b;
  }
  .cls-7 {
    stroke: #2b80b9;
  }
  .cls-10,
  .cls-14 {
    font-size: 11px;
  }
  .cls-11 {
    font-size: 17px;
  }
  .cls-12 {
    fill: #707070;
    stroke: #707070;
  }
  .cls-13,
  .cls-18 {
    font-size: 13px;
  }
  .cls-15 {
    clip-path: url(#clip-path);
  }
  .cls-16 {
    fill: #f95050;
  }
  .cls-17 {
    font-size: 12px;
  }
  .cls-19 {
    fill-rule: evenodd;
  }
  .cls-20 {
    fill: #121212;
  }
  .cls-21 {
    font-size: 6px;
  }
  .cls-22,
  .cls-23 {
    stroke: #fff;
  }
  .cls-22 {
    stroke-width: 2px;
  }
  .cls-25,
  .cls-26 {
    stroke: none;
  }
  .cls-27 {
    filter: url(#Rectangle_1458);
  }
  .cls-28 {
    filter: url(#Rectangle_1510);
  }
  .cls-29 {
    filter: url(#Rectangle_1448);
  }
  .cls-30 {
    filter: url(#Rectangle_1476);
  }
  .cls-31 {
    filter: url(#Rectangle_1463);
  }
  .cls-32 {
    filter: url(#Rectangle_1507);
  }
`;

export const ActiveCheckin = () => (
  <ActiveCheckinStyle>
    <svg
      height="32"
      id="artboard-svg"
      width="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="clip-path">
          <path className="cls-1" d="M0 0h6v6H0z" />
        </clipPath>
        <clipPath id="clip-checkIn_viewCheckInColView">
          <path d="M0 0h375v667H0z" />
        </clipPath>
      </defs>
      <g transform="translate(-120 -622)">
        <g className="cls-2" id="checkIn_viewCheckInColView">
          <g id="Home" transform="translate(53)">
            <g className="cls-24" id="Path_130" data-name="Path 130">
              <path
                className="cls-25"
                d="M14.267 27.535a13.18 13.18 0 0 1-9.381-3.886A13.18 13.18 0 0 1 1 14.267a13.18 13.18 0 0 1 3.886-9.381A13.18 13.18 0 0 1 14.267 1a13.18 13.18 0 0 1 9.382 3.886 13.18 13.18 0 0 1 3.886 9.381 13.18 13.18 0 0 1-3.886 9.382 13.18 13.18 0 0 1-9.382 3.886z"
                transform="translate(67.78 622.204)"
              />
              <path
                className="cls-26"
                d="M14.267 2a12.187 12.187 0 0 0-8.674 3.593A12.187 12.187 0 0 0 2 14.267c0 3.277 1.276 6.358 3.593 8.675a12.187 12.187 0 0 0 8.674 3.593c3.277 0 6.358-1.276 8.675-3.593a12.187 12.187 0 0 0 3.593-8.675c0-3.276-1.276-6.357-3.593-8.674A12.187 12.187 0 0 0 14.267 2m0-2c7.88 0 14.268 6.388 14.268 14.267 0 7.88-6.388 14.268-14.268 14.268C6.387 28.535 0 22.147 0 14.267 0 6.387 6.388 0 14.267 0z"
                transform="translate(67.78 622.204)"
              />
            </g>
            <g
              id="check-mark-in-a-circle_1_"
              transform="translate(74.407 628.407)"
              data-name="check-mark-in-a-circle (1)"
            >
              <path
                className="cls-20"
                id="Path_140"
                d="M6.992 0a6.992 6.992 0 1 0 6.992 6.992A7 7 0 0 0 6.992 0zm3.083 6.249L7.081 9.243a1.067 1.067 0 0 1-1.508 0L3.91 7.579a1.066 1.066 0 1 1 1.508-1.507l.909.909 2.24-2.24a1.066 1.066 0 0 1 1.507 1.508z"
                transform="translate(.609 .609)"
                data-name="Path 140"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </ActiveCheckinStyle>
);

const InactiveCheckinStyle = styled(Box)`
  .cls-1 {
    fill: none;
  }
  .cls-2 {
    clip-path: url(#clip-checkIn_viewCheckInColView_1);
  }
  .cls-10,
  .cls-22,
  .cls-26,
  .cls-3,
  .cls-7 {
    fill: #fff;
  }
  .cls-13,
  .cls-4,
  .cls-5,
  .cls-8 {
    fill: #263039;
  }
  .cls-4 {
    font-size: 21px;
  }
  .cls-10,
  .cls-17,
  .cls-4 {
    font-family: AvenirNext-Bold, Avenir Next;
    font-weight: 700;
  }
  .cls-5,
  .cls-6 {
    font-size: 14px;
  }
  .cls-11,
  .cls-13,
  .cls-18,
  .cls-21,
  .cls-5,
  .cls-6 {
    font-family: AvenirNext-DemiBold, Avenir Next;
    font-weight: 300;
  }
  .cls-11,
  .cls-14,
  .cls-17,
  .cls-18,
  .cls-19,
  .cls-21,
  .cls-6,
  .cls-9 {
    fill: #969a9b;
  }
  .cls-7 {
    stroke: #2b80b9;
  }
  .cls-10,
  .cls-14 {
    font-size: 11px;
  }
  .cls-11 {
    font-size: 17px;
  }
  .cls-12 {
    fill: #707070;
    stroke: #707070;
  }
  .cls-13,
  .cls-18 {
    font-size: 13px;
  }
  .cls-15 {
    clip-path: url(#clip-path);
  }
  .cls-16 {
    fill: #f95050;
  }
  .cls-17 {
    font-size: 12px;
  }
  .cls-19 {
    fill-rule: evenodd;
  }
  .cls-20,
  .cls-23,
  .cls-24 {
    fill: #121212;
  }
  .cls-21 {
    font-size: 6px;
  }
  .cls-22 {
    stroke: #fff;
    stroke-width: 2px;
  }
  .cls-24 {
    stroke: #121212;
  }
  .cls-25,
  .cls-26 {
    stroke: none;
  }
  .cls-27 {
    filter: url(#Rectangle_1458);
  }
  .cls-28 {
    filter: url(#Rectangle_1510);
  }
  .cls-29 {
    filter: url(#Rectangle_1448);
  }
  .cls-30 {
    filter: url(#Rectangle_1476);
  }
  .cls-31 {
    filter: url(#Rectangle_1463);
  }
  .cls-32 {
    filter: url(#Rectangle_1507);
  }
`;

export function InactiveCheckin(props) {
  return (
    <InactiveCheckinStyle>
      <svg
        height="32"
        id="artboard-svg"
        width="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <clipPath id="clip-path">
            <path className="cls-1" d="M0 0h6v6H0z" />
          </clipPath>
          <clipPath id="clip-checkIn_viewCheckInColView_1">
            <path d="M0 0h375v667H0z" />
          </clipPath>
        </defs>
        <g transform="translate(-120 -622)">
          <g
            className="cls-2"
            id="checkIn_viewCheckInColView_1"
            data-name="checkIn_viewCheckInColView – 1"
          >
            <g id="Home" transform="translate(53)">
              <g className="cls-23" id="Path_130" data-name="Path 130">
                <path
                  className="cls-25"
                  d="M14.267 27.535a13.18 13.18 0 0 1-9.381-3.886A13.18 13.18 0 0 1 1 14.267a13.18 13.18 0 0 1 3.886-9.381A13.18 13.18 0 0 1 14.267 1a13.18 13.18 0 0 1 9.382 3.886 13.18 13.18 0 0 1 3.886 9.381 13.18 13.18 0 0 1-3.886 9.382 13.18 13.18 0 0 1-9.382 3.886z"
                  transform="translate(67.78 622.204)"
                />
                <path
                  className="cls-26"
                  d="M14.267 2a12.187 12.187 0 0 0-8.674 3.593A12.187 12.187 0 0 0 2 14.267c0 3.277 1.276 6.358 3.593 8.675a12.187 12.187 0 0 0 8.674 3.593c3.277 0 6.358-1.276 8.675-3.593a12.187 12.187 0 0 0 3.593-8.675c0-3.276-1.276-6.357-3.593-8.674A12.187 12.187 0 0 0 14.267 2m0-2c7.88 0 14.268 6.388 14.268 14.267 0 7.88-6.388 14.268-14.268 14.268C6.387 28.535 0 22.147 0 14.267 0 6.387 6.388 0 14.267 0z"
                  transform="translate(67.78 622.204)"
                />
              </g>
              <g
                id="check-mark-in-a-circle_1_"
                transform="translate(74.407 628.407)"
                data-name="check-mark-in-a-circle (1)"
              >
                <path
                  className="cls-3"
                  id="Path_140"
                  d="M6.992 0a6.992 6.992 0 1 0 6.992 6.992A7 7 0 0 0 6.992 0zm3.083 6.249L7.081 9.243a1.067 1.067 0 0 1-1.508 0L3.91 7.579a1.066 1.066 0 1 1 1.508-1.507l.909.909 2.24-2.24a1.066 1.066 0 0 1 1.507 1.508z"
                  transform="translate(.609 .609)"
                  data-name="Path 140"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </InactiveCheckinStyle>
  );
}

const InactiveLogStyle = styled(Box)`
  .cls-1,
  .cls-22 {
    fill: none;
  }
  .cls-2 {
    clip-path: url(#clip-checkIn_viewCheckInColView);
  }
  .cls-10,
  .cls-23,
  .cls-24,
  .cls-26,
  .cls-3,
  .cls-7 {
    fill: #fff;
  }
  .cls-13,
  .cls-4,
  .cls-5,
  .cls-8 {
    fill: #263039;
  }
  .cls-4 {
    font-size: 21px;
  }
  .cls-10,
  .cls-17,
  .cls-4 {
    font-family: AvenirNext-Bold, Avenir Next;
    font-weight: 700;
  }
  .cls-5,
  .cls-6 {
    font-size: 14px;
  }
  .cls-11,
  .cls-13,
  .cls-18,
  .cls-21,
  .cls-5,
  .cls-6 {
    font-family: AvenirNext-DemiBold, Avenir Next;
    font-weight: 300;
  }
  .cls-11,
  .cls-14,
  .cls-17,
  .cls-18,
  .cls-19,
  .cls-21,
  .cls-6,
  .cls-9 {
    fill: #969a9b;
  }
  .cls-7 {
    stroke: #2b80b9;
  }
  .cls-10,
  .cls-14 {
    font-size: 11px;
  }
  .cls-11 {
    font-size: 17px;
  }
  .cls-12 {
    fill: #707070;
    stroke: #707070;
  }
  .cls-13,
  .cls-18 {
    font-size: 13px;
  }
  .cls-15 {
    clip-path: url(#clip-path);
  }
  .cls-16 {
    fill: #f95050;
  }
  .cls-17 {
    font-size: 12px;
  }
  .cls-19 {
    fill-rule: evenodd;
  }
  .cls-20 {
    fill: #121212;
  }
  .cls-21 {
    font-size: 6px;
  }
  .cls-22,
  .cls-23 {
    stroke: #fff;
  }
  .cls-22 {
    stroke-width: 2px;
  }
  .cls-25,
  .cls-26 {
    stroke: none;
  }
  .cls-27 {
    filter: url(#Rectangle_1458);
  }
  .cls-28 {
    filter: url(#Rectangle_1510);
  }
  .cls-29 {
    filter: url(#Rectangle_1448);
  }
  .cls-30 {
    filter: url(#Rectangle_1476);
  }
  .cls-31 {
    filter: url(#Rectangle_1463);
  }
  .cls-32 {
    filter: url(#Rectangle_1507);
  }
`;

export const InactiveLog = () => (
  <InactiveLogStyle>
    <svg
      height="32"
      id="artboard-svg"
      width="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="clip-path">
          <path className="cls-1" d="M0 0h6v6H0z" />
        </clipPath>
        <clipPath id="clip-checkIn_viewCheckInColView">
          <path d="M0 0h375v667H0z" />
        </clipPath>
      </defs>
      <g transform="translate(-225 -622)">
        <g className="cls-2" id="checkIn_viewCheckInColView">
          <g id="Leaves" transform="translate(53)">
            <g
              className="cls-22"
              id="Ellipse_29"
              transform="translate(172.882 622.465)"
              data-name="Ellipse 29"
            >
              <circle className="cls-25" cx="14.267" cy="14.267" r="14.267" />
              <circle className="cls-1" cx="14.267" cy="14.267" r="13.267" />
            </g>
            <g id="edit" transform="translate(181.97 629.79)">
              <g
                id="Group_358"
                transform="translate(0 .358)"
                data-name="Group 358"
              >
                <path
                  className="cls-23"
                  id="Path_137"
                  d="M102.337 3.973l-1.184 1.184c-.436.436-.875.872-1.309 1.314a.814.814 0 0 0-.209.381c-.157.72-.309 1.441-.461 2.161l-.085.4a.568.568 0 0 0 .145.521.556.556 0 0 0 .394.16.732.732 0 0 0 .127-.012l.439-.092c.7-.147 1.4-.3 2.1-.441a.813.813 0 0 0 .416-.224q2.939-2.943 5.878-5.878a.826.826 0 0 0 .244-.528.347.347 0 0 0-.007-.1c-.012-.05-.022-.1-.035-.152a2.2 2.2 0 0 0-.117-.411 3.25 3.25 0 0 0-1.812-1.778 2 2 0 0 0-.5-.11h-.042a.7.7 0 0 0-.606.227q-1.681 1.685-3.376 3.378zm3.9-3.009h.054a1.31 1.31 0 0 1 .344.07 2.663 2.663 0 0 1 1.478 1.451 1.552 1.552 0 0 1 .08.289c.007.04.017.08.025.12a.189.189 0 0 1-.062.107q-2.943 2.935-5.88 5.878a.2.2 0 0 1-.107.057l-2.1.441-.369.077.07-.327c.152-.718.3-1.438.459-2.156a.218.218 0 0 1 .047-.082q.651-.658 1.3-1.309l1.19-1.18q1.694-1.694 3.385-3.39c.049-.038.07-.046.087-.046z"
                  transform="translate(-96.606 -.358)"
                  data-name="Path 137"
                />
                <path
                  className="cls-23"
                  id="Path_138"
                  d="M.97 85.392h4.352a.307.307 0 1 0 0-.613H.97a.971.971 0 0 0-.97.97v8.161a.971.971 0 0 0 .97.97h8.158a.971.971 0 0 0 .97-.97v-4.175a.307.307 0 1 0-.613 0v4.175a.361.361 0 0 1-.359.359H.97a.361.361 0 0 1-.359-.359v-8.159a.361.361 0 0 1 .359-.359z"
                  transform="translate(0 -82.675)"
                  data-name="Path 138"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </InactiveLogStyle>
);

const ActiveLogStyle = styled(Box)`
  .cls-1 {
    fill: none;
  }
  .cls-2 {
    clip-path: url(#clip-checkIn_viewCheckInColView_1);
  }
  .cls-10,
  .cls-22,
  .cls-26,
  .cls-3,
  .cls-7 {
    fill: #fff;
  }
  .cls-13,
  .cls-4,
  .cls-5,
  .cls-8 {
    fill: #263039;
  }
  .cls-4 {
    font-size: 21px;
  }
  .cls-10,
  .cls-17,
  .cls-4 {
    font-family: AvenirNext-Bold, Avenir Next;
    font-weight: 700;
  }
  .cls-5,
  .cls-6 {
    font-size: 14px;
  }
  .cls-11,
  .cls-13,
  .cls-18,
  .cls-21,
  .cls-5,
  .cls-6 {
    font-family: AvenirNext-DemiBold, Avenir Next;
    font-weight: 300;
  }
  .cls-11,
  .cls-14,
  .cls-17,
  .cls-18,
  .cls-19,
  .cls-21,
  .cls-6,
  .cls-9 {
    fill: #969a9b;
  }
  .cls-7 {
    stroke: #2b80b9;
  }
  .cls-10,
  .cls-14 {
    font-size: 11px;
  }
  .cls-11 {
    font-size: 17px;
  }
  .cls-12 {
    fill: #707070;
    stroke: #707070;
  }
  .cls-13,
  .cls-18 {
    font-size: 13px;
  }
  .cls-15 {
    clip-path: url(#clip-path);
  }
  .cls-16 {
    fill: #f95050;
  }
  .cls-17 {
    font-size: 12px;
  }
  .cls-19 {
    fill-rule: evenodd;
  }
  .cls-20,
  .cls-23,
  .cls-24 {
    fill: #121212;
  }
  .cls-21 {
    font-size: 6px;
  }
  .cls-22 {
    stroke: #fff;
    stroke-width: 2px;
  }
  .cls-23 {
    stroke: #121212;
  }
  .cls-25,
  .cls-26 {
    stroke: none;
  }
  .cls-27 {
    filter: url(#Rectangle_1458);
  }
  .cls-28 {
    filter: url(#Rectangle_1510);
  }
  .cls-29 {
    filter: url(#Rectangle_1448);
  }
  .cls-30 {
    filter: url(#Rectangle_1476);
  }
  .cls-31 {
    filter: url(#Rectangle_1463);
  }
  .cls-32 {
    filter: url(#Rectangle_1507);
  }
`;

export function ActiveLog(props) {
  return (
    <ActiveLogStyle>
      <svg
        height="32"
        id="artboard-svg"
        width="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <clipPath id="clip-path">
            <path className="cls-1" d="M0 0h6v6H0z" />
          </clipPath>
          <clipPath id="clip-checkIn_viewCheckInColView_1">
            <path d="M0 0h375v667H0z" />
          </clipPath>
        </defs>
        <g transform="translate(-225 -622)">
          <g
            className="cls-2"
            id="checkIn_viewCheckInColView_1"
            data-name="checkIn_viewCheckInColView – 1"
          >
            <g id="Leaves" transform="translate(53)">
              <g
                className="cls-22"
                id="Ellipse_29"
                transform="translate(172.882 622.465)"
                data-name="Ellipse 29"
              >
                <circle className="cls-25" cx="14.267" cy="14.267" r="14.267" />
                <circle className="cls-1" cx="14.267" cy="14.267" r="13.267" />
              </g>
              <g id="edit" transform="translate(181.97 629.79)">
                <g
                  id="Group_358"
                  transform="translate(0 .358)"
                  data-name="Group 358"
                >
                  <path
                    className="cls-23"
                    id="Path_137"
                    d="M102.337 3.973l-1.184 1.184c-.436.436-.875.872-1.309 1.314a.814.814 0 0 0-.209.381c-.157.72-.309 1.441-.461 2.161l-.085.4a.568.568 0 0 0 .145.521.556.556 0 0 0 .394.16.732.732 0 0 0 .127-.012l.439-.092c.7-.147 1.4-.3 2.1-.441a.813.813 0 0 0 .416-.224q2.939-2.943 5.878-5.878a.826.826 0 0 0 .244-.528.347.347 0 0 0-.007-.1c-.012-.05-.022-.1-.035-.152a2.2 2.2 0 0 0-.117-.411 3.25 3.25 0 0 0-1.812-1.778 2 2 0 0 0-.5-.11h-.042a.7.7 0 0 0-.606.227q-1.681 1.685-3.376 3.378zm3.9-3.009h.054a1.31 1.31 0 0 1 .344.07 2.663 2.663 0 0 1 1.478 1.451 1.552 1.552 0 0 1 .08.289c.007.04.017.08.025.12a.189.189 0 0 1-.062.107q-2.943 2.935-5.88 5.878a.2.2 0 0 1-.107.057l-2.1.441-.369.077.07-.327c.152-.718.3-1.438.459-2.156a.218.218 0 0 1 .047-.082q.651-.658 1.3-1.309l1.19-1.18q1.694-1.694 3.385-3.39c.049-.038.07-.046.087-.046z"
                    transform="translate(-96.606 -.358)"
                    data-name="Path 137"
                  />
                  <path
                    className="cls-23"
                    id="Path_138"
                    d="M.97 85.392h4.352a.307.307 0 1 0 0-.613H.97a.971.971 0 0 0-.97.97v8.161a.971.971 0 0 0 .97.97h8.158a.971.971 0 0 0 .97-.97v-4.175a.307.307 0 1 0-.613 0v4.175a.361.361 0 0 1-.359.359H.97a.361.361 0 0 1-.359-.359v-8.159a.361.361 0 0 1 .359-.359z"
                    transform="translate(0 -82.675)"
                    data-name="Path 138"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </ActiveLogStyle>
  );
}

export function PinIcon({ className }) {
  return (
    <div className={className}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        data-icon="thumbtack"
        className="svg-inline--fa fa-thumbtack fa-w-12"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 384 512"
      >
        <path
          fill="#ee8338"
          d="M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"
        ></path>
      </svg>
    </div>
  );
}

export function UnpinIcon({ className }) {
  return (
    <div className={className}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        data-icon="thumbtack"
        className="svg-inline--fa fa-thumbtack fa-w-12"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 384 512"
      >
        <path
          fill="#ffffff"
          d="M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"
        ></path>
      </svg>
    </div>
  );
}
